module.exports = __webpack_public_path__ + "img/up-nexus-icon.d6862131.svg";